import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 2.75C6.21979 2.75 2.75 6.21979 2.75 10.5C2.75 14.7802 6.21979 18.25 10.5 18.25C14.7802 18.25 18.25 14.7802 18.25 10.5C18.25 6.21979 14.7802 2.75 10.5 2.75ZM1.25 10.5C1.25 5.39137 5.39137 1.25 10.5 1.25C15.6086 1.25 19.75 5.39137 19.75 10.5C19.75 12.7843 18.922 14.8752 17.5497 16.489L21.3839 20.3233C21.6768 20.6162 21.6768 21.091 21.3839 21.3839C21.091 21.6768 20.6162 21.6768 20.3233 21.3839L16.489 17.5497C14.8753 18.922 12.7843 19.75 10.5 19.75C5.39137 19.75 1.25 15.6086 1.25 10.5ZM7.1413 6.64124C8.00006 5.78248 9.18859 5.25 10.5001 5.25C11.8115 5.25 13.0001 5.78248 13.8588 6.64124C14.1517 6.93414 14.1517 7.40901 13.8588 7.7019C13.5659 7.9948 13.091 7.9948 12.7982 7.7019C12.2092 7.11295 11.3977 6.75 10.5001 6.75C9.60239 6.75 8.79092 7.11295 8.20196 7.7019C7.90907 7.9948 7.43419 7.9948 7.1413 7.7019C6.84841 7.40901 6.84841 6.93414 7.1413 6.64124Z"
      fill="currentColor"
    />
  </svg>
);
